module.exports = __webpack_public_path__ + "img/logo.c299d2ff.svg";